export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./project.item.vue?vue&type=template&id=1a91c418&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/views/project/project.item.vue?vue&type=template&id=1a91c418&scoped=true&
// module id = 747
// module chunks = 2